import React from 'react';
import { arrayOf, func, objectOf, any } from 'prop-types';
import classNames from 'classnames';
import { Formik } from 'formik';
import * as Yup from 'yup';

import SmartField from './SmartField';
import './SmartForm.scss';
import { smartFromFieldType } from './types';

const SmartForm = React.forwardRef(
  (
    {
      fields,
      handleSubmit,
      renderInput,
      className = '',
      grid = false,
      children,
      state,
      options = null,
      autosave = false,
      ...rest
    },
    ref,
  ) => {
    const initialValues = {};
    const validationSchema = {};
    fields.forEach((field) => {
      initialValues[field.name] = state[field.name] || field.initialValue;
      validationSchema[field.name] = field.validation;
    });
    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={Yup.object(validationSchema)}
        onSubmit={handleSubmit}
      >
        {(props) => {
          if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.current = props;
          }
          return (
            <div
              className={classNames('smart-form', { grid }, className)}
              {...rest}
            >
              {fields.map((field) => {
                let rendered;
                if (renderInput)
                  rendered = renderInput({ field, props, autosave });

                const input = { ...field.input };
                if (options && options[field.name]) {
                  input.options = options[field.name];
                }
                return (
                  rendered || (
                    <SmartField
                      key={field.name}
                      autosave={autosave}
                      name={field.name}
                      input={input}
                      {...props}
                    />
                  )
                );
              })}
              {children}
            </div>
          );
        }}
      </Formik>
    );
  },
);

SmartForm.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  fields: [],
  state: {},
  renderInput: null,
};

SmartForm.propTypes = {
  fields: arrayOf(smartFromFieldType).isRequired,
  state: objectOf(any),
  handleSubmit: func,
  renderInput: func,
};

export default SmartForm;
